import { isDev } from "./host";

export default {
  aws_project_region: "eu-west-1",
  aws_cognito_identity_pool_id: "eu-west-1:24230ef0-a317-4cef-814b-ffc46f882bd9",
  aws_cognito_region: "eu-west-1",
  aws_user_pools_id: isDev ? "eu-west-1_QPtu8TbsN" : "eu-west-1_GRBRFKqCc",
  aws_user_pools_web_client_id: isDev ? "4culqf885lnfb51uel7cia82ie" : "51qhi4os82uroccd7pa49coi72",
  oauth: {
    // domain: "localhost:3000",
    // redirectSignIn: "http://localhost:3000/", // Change this to your PROD URL
    // redirectSignOut: "http://localhost:3000/", // Change this to your PROD URL
    // responseType: "token",
  },
};
